import { Link, useNavigate } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { useSession } from '@/lib/auth-client'
import { canSubscribe } from '@/lib/billing/gateways/availability'
import { formatTrialAllowance, TRIAL_PLAN_SLUG } from '@/lib/billing/trial'
import { publicTrialOffer } from '@/lib/billing/trial-offer-runtime'

/**
 * One quiet line above the public header: the free trial exists. Renders
 * nothing while the offer is off or the card rail is down (the trial is a
 * Stripe subscription). Signed-in visitors go to their billing page where the
 * offer card starts the trial; everyone else goes through signup.
 */
export function TrialBanner() {
  const offer = publicTrialOffer()
  const { data: session, isPending } = useSession()
  const authed = !isPending && !!session
  const navigate = useNavigate()
  if (!offer || !canSubscribe()) return null

  return (
    <div className="border-b bg-muted/40">
      <Link
        to="/signup"
        search={{ plan: TRIAL_PLAN_SLUG, trial: true }}
        onClick={(e) => {
          if (!authed) return
          e.preventDefault()
          navigate({
            to: '/billing',
            search: { subscribe: TRIAL_PLAN_SLUG, trial: true },
          })
        }}
        className="group mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2 text-sm text-muted-foreground"
      >
        <span>
          Try {formatTrialAllowance(offer.allowanceBytes)} of US mobile proxy
          data free for {offer.days} days.
        </span>
        <span className="inline-flex items-center gap-1 font-medium text-foreground underline-offset-4 group-hover:underline">
          Start free trial
          <ArrowRight className="size-3.5" aria-hidden />
        </span>
      </Link>
    </div>
  )
}
